/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable camelcase */
/* eslint-disable no-nested-ternary */
import React from "react";
import PropTypes from "prop-types";
import { getObjectValue } from "gatsby-core-theme/src/helpers/getters";
import keygen from "gatsby-core-theme/src/helpers/keygen";
import useTranslate from "~hooks/useTranslate/useTranslate";
import { operatorRatings } from "../../../constants/ratings-constant";

import styles from "./ratings.module.scss";

export default function Ratings({
  item,
  type,
  numOfStars = 5,
  currency = "€",
}) {
  const typeCheck =
    type === "operator"
      ? item?.type === "casino"
        ? "operator"
        : item?.type
      : type;
    
  const ratings = operatorRatings[typeCheck] || [];

  const rangeText = {
    0: useTranslate("range_low", "Low"),
    1: useTranslate("range_medium", "Medium"),
    2: useTranslate("range_high", "High"),
  };

  if (!ratings.length) {
    return null;
  }

  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    <ul className={`${styles?.ratingList || ""}`} tabIndex={0}>
      {ratings?.map((rating) => {
        const { fieldValue, translationKey, fieldLabel, componentToUse } =
          rating || {};
        let valueDiplayed;
        const value = getObjectValue(item, fieldValue);
        const component = componentToUse
          ? componentToUse(numOfStars, value, currency)
          : false;

        if (component && value) {
          valueDiplayed = component || "-";
        } else if (fieldValue.includes("volatility")) {
          valueDiplayed =
            rangeText[getObjectValue(item, fieldValue)] || "-";
        } else {
          valueDiplayed = value || "-";
        }

        if (["coming_soon", "inactive"].includes(item?.status)) {
          valueDiplayed = "TBA";
        }

        return (
          <li
            key={keygen()}
            className={`${styles?.item || ""} ${
              rating?.showOnlyMobile ? styles?.showOnlyMobile || "" : ""
            }`}
          >
            <p className={styles?.label || ""}>
              {useTranslate(translationKey, fieldLabel)}
            </p>

            {valueDiplayed === "TBA" ? (
              <p className={`${styles?.value || ""} ${styles?.tbaValue}`}>
                {useTranslate("tba", "TBA")}
              </p>
            ) : (
              <>
                {valueDiplayed}
                {(typeof valueDiplayed === 'number' && fieldValue === "rtp" )&& "%"}
              </>
            )}
          </li>
        );
      })}
    </ul>
  );
}

Ratings.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string,
    bonus: PropTypes.shape({}),
    rating: PropTypes.string,
    status: PropTypes.string,
    rating_bonuses: PropTypes.string,
    rating_casino: PropTypes.string,
    rating_customer: PropTypes.string,
    rating_games: PropTypes.string,
    rating_payout: PropTypes.string,
    first_rating: PropTypes.string,
    second_rating: PropTypes.string,
    third_rating: PropTypes.string,
    fourth_rating: PropTypes.string,
    type: PropTypes.string,
  }),
  type: PropTypes.string,
  numOfStars: PropTypes.number,
  currency: PropTypes.string,
};
